import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { heading4 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';

export const WorkflowTitleText = styled.div`
  padding: ${pxToRem(1)};
  ${heading4};

  color: ${({ $showPublishedHeader }: { $showPublishedHeader: boolean }) =>
    $showPublishedHeader ? colors.textPrimary : colors.white};
`;

export const StyledWorkflowTitle = styled.div`
  display: flex;
  align-items: center;
  overflow-x: hidden;

  > :first-child {
    width: 100%;
  }
`;

export const WorkflowMenu = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  padding: 0 ${spacing.threeQuarter};
`;
